import { useQuery } from '@tanstack/react-query';
import BshopService from '../BshopService';

export const GetBshop = (formData, options) => useQuery({
  queryKey: ['getBshop', formData],
  queryFn: async () => {
    try {
      const response = await BshopService.GetBshop(formData);
      return response.data;
    } catch (validationError) {
      throw new Error(`Error de validación de formData: ${  validationError.errors.join(', ')}`);
    }
  },
  options
});

export const FindBshop = (formData, options) => useQuery({
  queryKey: ['findBshop', formData],
  queryFn: async () => {
    try {
      const response = await BshopService.FindBshop(formData);
      return response.data;
    } catch (validationError) {
      throw new Error(`Error de validación de formData: ${  validationError.errors.join(', ')}`);
    }
  },
  options
});

export const GetCity = (formData, options) => useQuery({
  queryKey: ['getCity', formData],
  queryFn: async () => {
    try {
      const response = await BshopService.GetCity(formData);
      return response.data;
    } catch (validationError) {
      throw new Error(`Error de validación de formData: ${  validationError.errors.join(', ')}`);
    }
  },
  options
});